<template>
  <div>
    <v-card color="grey lighten-4" light>
      <v-card-title>
        <span class="headline">Cargar datos al sistema</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" lg="12" sm="12" md="12">
              <v-form ref="form">
                <v-file-input
                  ref="fileTracking"
                  counter
                  show-size
                  truncate-length="50"
                  @change="changeInputFile()"
                  :loading="loadingInputFile"
                  :success="successInputFile"
                  :success-messages="successMessagesInputFile"
                  :error="errorInputFile"
                  :error-messages="errorMessagesInputFile"
                ></v-file-input>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog">Cancelar</v-btn>
        <v-btn color="success" @click="submitForm">Cargar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { postApi } from "../service/api";

export default {
  name: "dialog-uploads-file",
  props: ["headers"],
  components: {},
  data: function () {
    return {
      data: [],
      valid: false,
      loadingInputFile: false,
      successInputFile: false,
      successMessagesInputFile: "",
      errorInputFile: false,
      errorMessagesInputFile: "",
    };
  },

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    changeInputFile() {
      this.successInputFile = false;
      this.successMessagesInputFile = "";
      this.errorInputFile = false;
      this.errorMessagesInputFile = "";
      if (
        this.$refs.fileTracking.lazyValue.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.errorInputFile = true;
        this.errorMessagesInputFile =
          "Verificar el archivo, el subido no posee la extensión de hoja de datos Excel";
      }
      // console.log('Change', file)
    },
    async submitForm() {
      // Inicializamos formData
      let formData = new FormData();

      // Las facturas correctas están en this.filesFactura
      formData.append("fileTracking", this.$refs.fileTracking.lazyValue);

      const data = {
        url: `${process.env.VUE_APP_RUTA_API}/api/v01/tracking/uploadsFileExcel/`,
        data: formData,
      };

      try {
        this.loadingInputFile = true;
        const res = await postApi(data);
        console.log("res", res);
        this.loadingInputFile = false;
        this.successInputFile = true;
        this.successMessagesInputFile =
          "La información ha sido cargada de forma correcta";
        setTimeout(() => {
          this.closeDialog();
          this.$refs.fileTracking.lazyValue = [];
          this.successInputFile = false;
          this.successMessagesInputFile = '';
        }, 5000);
      } catch (error) {
        this.loadingInputFile = false;
        this.errorInputFile = true;
        this.errorMessagesInputFile = error.response.data?.detail;
      }
    },
  },
};
</script>
